import AmexBenefitCard from './AmexGDAOffersBenefitCard';

export default AmexBenefitCard;
